var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PAUSED-LEADS-LIST-PLACEHOLDER"},[_c('span',{staticClass:"c-gray70 p-b-4 MESSAGE"},[_vm._v("\n    You have no paused lead dates.\n    Pause your leads to save points when you’re busy or need a break.\n  ")]),_c('img',{attrs:{"alt":"pausedLeads","src":require("./assets/EmptySuccessVacation.svg")}})])
}]

export { render, staticRenderFns }